import { Quill } from 'react-quill'; // ES6

const Embed = Quill.import('blots/block/embed');

class EditorName extends Embed {
    static create(value) {
        let node = super.create(value);
        node.setAttribute('disabled', 'disabled');
        node.setAttribute('value', value.value);
        node.setAttribute('id', value.id);
        node.setAttribute(
            'style',
            'width:' + value.value.length * 12 + 'px !important;word-break: break-word;',
        );
        return node;
    }

    static value(domNode) {
        return {
            id: domNode.getAttribute('id'),
            value: domNode.getAttribute('value'),
        };
    }

    static id(domNode) {
        return domNode.getAttribute('id');
    }
}

EditorName.blotName = 'nombre';
EditorName.tagName = 'input';
EditorName.className = 'nombre';
Quill.register(EditorName, true);

export default EditorName;



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/EditorName.js